<div
  class="container gap-4"
  [libLoading]="isLoading"
>
  <lib-header-page
    title="{{ 'purchaseDetails' | translate }}"
    [breadcrumbsItems]="breadcrumbs"
  >
    <div
      right-content
      class="flex gap-2"
    >
      @if (purchaseData.status === statusPurchaseType.PendingReview && !isViewDetail) {
        <p-button
          label="{{ 'approve' | translate }}"
          icon="fa fa-circle-check"
          (onClick)="approveStatus(purchaseData)"
        />
        <p-button
          label="{{ 'rejected' | translate }}"
          [severity]="'danger'"
          icon="fa fa-circle-xmark"
          (onClick)="rejectedStatus(purchaseData)"
        />
      }

      @if (purchaseData.status === statusPurchaseType.PendingPayment && !isViewDetail) {
        <p-button
          label="{{ 'paymentResultRecord' | translate }}"
          (onClick)="onPaymentResultRecord(purchaseData)"
        />
      }

      <p-button
        label="{{ 'back' | translate }}"
        [severity]="'secondary'"
        outlined
        (onClick)="goBack()"
      />
    </div>
  </lib-header-page>
  <p-card>
    <e-general-information [purchaseData]="purchaseData"></e-general-information>
    <p-panel
      [header]="('listOfPurchasedProducts' | translate) + '( ' + rows?.length + ' ' + ('items' | translate) + ' )'"
      [toggleable]="true"
      styleClass="_panel-wrapper"
    >
      <lib-grid
        #grid
        [dataSub]="dataSub"
        [columns]="columns"
        [rows]="rows"
        [(page)]="page"
        (pageChange)="pageChange()"
        [sort]="sort"
        (sortChange)="sortChange($event)"
        [inCard]="false"
        [isShowPaginate]="false"
        (edit)="edit($event)"
      />
    </p-panel>
    <div class="_g-border-top-dashed"></div>

    <e-payment-method
      [purchaseData]="purchaseData"
      [bankData]="bankData"
    >
    </e-payment-method>

    <div class="_total-wrapper">
      <div class="_total-amount flex justify-end bg-primary">
        <span class="mr-3 text-xl text-white">{{ "purchaseDetailList.total" | translate }}</span>
        <!-- ฿ -->
        <p class="text-3xl font-semibold text-white">{{ purchaseData.sumAmount | number: "1.2" : "en-US" }}</p>
        <span class="ml-3 text-xl text-white">{{ "memberTier.baht" | translate }}</span>
      </div>
    </div>
  </p-card>
</div>

<ng-template
  #nameTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <div class="flex items-center">
    @if (row.productImageUrl) {
      <div class="_size-image mr-2 mt-2">
        <p-image
          [src]="row.productImageUrl"
          alt="Image"
          [preview]="true"
        />
      </div>
    }

    <p-button
      label="{{ value.translations | translations: 'name' }}"
      [link]="true"
      (click)="onViewProduct(row)"
      styleClass="p-0 text-left"
    />
  </div>
</ng-template>

<ng-template
  #weighingInTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  {{ value | number: "1.2" : "en-US" }}
</ng-template>

<ng-template
  #weighingOutTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  {{ value | number: "1.2" : "en-US" }}
</ng-template>

<ng-template
  #numberPieTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <span>
    {{ !value ? "-" : (value | number: "1.2" : "en-US") }}
  </span>
</ng-template>

<ng-template
  #priceTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <div class="grid">
    <div>
      <span>
        {{ !value ? "-" : (value | number: "1.2" : "en-US") }}
      </span>
      <!-- @if (!row.useSpecialPrice) {
        <i class="fa fa-check ml-1 text-xs text-primary"></i>
      } -->
    </div>
    @if (row.specialPricePerUnit) {
      <div>
        <span>
          {{ "purchaseDetailList.requestSpecialPrice" | translate }}
          {{ row.specialPricePerUnit | number: "1.2" : "en-US" }}
        </span>
        @if (row.useSpecialPrice) {
          <i class="fa fa-check ml-1 text-xs text-primary"></i>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template
  #numberDecimalPieTpl
  let-row="row"
  let-value="value"
  let-column="column"
>
  <span>
    {{ value | number: "1.2" : "en-US" }}
  </span>
</ng-template>

<ng-template
  #actionTpl
  let-row="row"
  let-column="column"
>
  <div class="flex items-center justify-center gap-1">
    @if (purchaseData.status === statusPurchaseType.PendingReview && !isViewDetail) {
      <p-button
        icon="pi pi-file-edit"
        severity="warn"
        text
        [pTooltip]="'lib.grid.edit' | translate"
        appendTo="body"
        tooltipPosition="top"
        (click)="edit(row)"
      />
    }
  </div>
</ng-template>

<!-- NOTE: บันทึกผลการชำระเงิน -->
<lib-modal
  #paymentResultRecordModal
  [title]="'paymentResultRecord' | translate"
  modalType="form"
  modalSize="xl"
  (close)="onCloseFormPaymentResultRecord()"
  (closeForm)="onCloseFormPaymentResultRecord()"
  (submitForm)="formPaymentResultRecord.ngSubmit.emit(formPaymentResultRecord)"
>
  <!-- <div>content</div> -->
  @if (paymentResultRecordModal.isOpen()) {
    <form
      #formPaymentResultRecord="ngForm"
      (ngSubmit)="onSubmitPaymentResultRecord($event)"
      [class.ng-submitted]="formPaymentResultRecord.submitted"
    >
      <shared-payment-result-record-form
        #paymentResultRecordForm
        [purchaseData]="purchaseData"
      >
      </shared-payment-result-record-form>
    </form>
  }
</lib-modal>

<!-- NOTE: Rejected -->
<lib-modal
  #rejectedModal
  [title]="'purchaseDetailList.recordReasonsForDisapproval' | translate"
  modalType="form"
  (close)="rejectedModal.close()"
  (closeForm)="rejectedModal.close()"
  (submitForm)="formRejected.ngSubmit.emit(formRejected)"
>
  @if (rejectedModal.isOpen()) {
    <form
      #formRejected="ngForm"
      (ngSubmit)="onSubmitRejected($event)"
      [class.ng-submitted]="formRejected.submitted"
    >
      <div class="formgrid">
        <div class="field">
          <label
            for="reason"
            class="is-required"
            >{{ "remark" | translate }}</label
          >
          <textarea
            class="_custom-text-area"
            id="reason"
            name="reason"
            rows="5"
            pTextarea
            [(ngModel)]="reason"
            required
            [placeholder]="'placeholderInput' | translate: { placeholder: 'remark' | translate }"
          ></textarea>
        </div>
      </div>
    </form>
  }
</lib-modal>

<!-- NOTE: สินค้าที่รับซื้อ -->
<lib-modal
  #productPurchasedModal
  [title]="'สินค้าที่รับซื้อ'"
  [modalType]="isEditPurchaseProduct ? 'form' : 'default'"
  modalSize="xl"
  (closeForm)="productPurchasedModal.close()"
  (submitForm)="formEditProduct.ngSubmit.emit(formEditProduct)"
>
  @if (productPurchasedModal.isOpen()) {
    @if (isEditPurchaseProduct) {
      <form
        #formEditProduct="ngForm"
        (ngSubmit)="onSubmitEditProduct($event)"
        [class.ng-submitted]="formEditProduct.submitted"
      >
        <div class="grid gap-x-4 sm:grid-cols-1 md:grid-cols-2">
          <div class="formgrid">
            <div class="field">
              <img
                [src]="purchaseProductData.productImageUrl"
                class="_product-imageUrl"
                imageFallback
              />
            </div>
          </div>

          <div class="formgrid container grid gap-x-4 sm:grid-cols-1 md:grid-cols-2">
            <div class="field">
              <label for="product">{{ "product" | translate }}</label>
              <lib-dynamic-dropdown
                [list]="productList"
                name="product"
                id="product"
                [(ngModel)]="product"
                required
                [placeholder]="'placeholderSelect' | translate: { placeholder: 'product' | translate }"
                (ngModelChange)="onChangProduct()"
              >
                <ng-template
                  dropdownSelectedItemTpl
                  let-selectedOption
                >
                  <div class="flex items-center gap-2">
                    <img
                      [src]="selectedOption.imageUrl"
                      class="h-[18px] w-[18px]"
                    />
                    <div>{{ selectedOption.name }}</div>
                  </div>
                </ng-template>
                <ng-template
                  dropdownItemTpl
                  let-item
                >
                  <div class="flex items-center gap-2">
                    <img
                      [src]="item.imageUrl"
                      class="h-[18px] w-[18px]"
                    />
                    <div>{{ item.name }}</div>
                  </div>
                </ng-template>
              </lib-dynamic-dropdown>
            </div>

            <div class="grid gap-x-4 sm:grid-cols-1 md:grid-cols-2">
              @if (purchaseData.isBulkSale) {
                <div class="field">
                  <label for="weightIn">{{ "purchaseDetailList.weightIn" | translate }}</label>
                  <p-inputnumber
                    [(ngModel)]="purchaseProductData.weightIn"
                    [pKeyFilter]="'num'"
                    id="weightIn"
                    name="weightIn"
                    mode="decimal"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    [placeholder]="'placeholderInput' | translate: { placeholder: 'purchaseDetailList.weightOut' | translate }"
                    (ngModelChange)="onWeightInChang()"
                    required
                  />
                  <!-- <span class="font-bold">{{ purchaseProductData.weightIn | number: "1.2" : "en-US" }} ตัน</span> -->
                </div>

                <div class="field">
                  <label
                    for="weightOut"
                    class="is-required"
                    >{{ "purchaseDetailList.weightOut" | translate }}</label
                  >
                  <p-inputnumber
                    [(ngModel)]="purchaseProductData.weightOut"
                    [pKeyFilter]="'num'"
                    id="weightOut"
                    name="weightOut"
                    mode="decimal"
                    [minFractionDigits]="2"
                    [maxFractionDigits]="2"
                    [placeholder]="'placeholderInput' | translate: { placeholder: 'purchaseDetailList.weightOut' | translate }"
                    (ngModelChange)="onWeightOutChang()"
                    required
                  />
                </div>
              }

              <div class="field">
                <label for="weight">{{ "purchaseDetailList.weighingWeight" | translate }}</label>
                <p-inputnumber
                  [(ngModel)]="purchaseProductData.weight"
                  [pKeyFilter]="'num'"
                  id="weight"
                  name="weight"
                  mode="decimal"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [placeholder]="'placeholderInput' | translate: { placeholder: 'purchaseDetailList.weighingWeight' | translate }"
                  (ngModelChange)="calculateWeight()"
                />
              </div>

              <div class="field">
                <label for="weightLoss">{{ "purchaseDetailList.weightLoss" | translate }}</label>
                <p-inputnumber
                  [(ngModel)]="purchaseProductData.weightLoss"
                  [pKeyFilter]="'num'"
                  id="weightLoss"
                  name="weightLoss"
                  mode="decimal"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [placeholder]="'placeholderInput' | translate: { placeholder: 'purchaseDetailList.weightLoss' | translate }"
                  (ngModelChange)="calculateWeightLoss()"
                />
              </div>

              <div class="field">
                <label for="pricePerUnit">{{ "price" | translate }}</label>
                <p-inputnumber
                  [(ngModel)]="purchaseProductData.pricePerUnit"
                  [pKeyFilter]="'num'"
                  id="pricePerUnit"
                  name="pricePerUnit"
                  mode="decimal"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [disabled]="true"
                />
              </div>

              <div class="field">
                <label for="specialPricePerUnit">{{ "purchaseDetailList.specialPrice" | translate }}</label>
                <p-inputnumber
                  [(ngModel)]="purchaseProductData.specialPricePerUnit"
                  [pKeyFilter]="'num'"
                  id="specialPricePerUnit"
                  name="specialPricePerUnit"
                  mode="decimal"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [placeholder]="'placeholderInput' | translate: { placeholder: 'purchaseDetailList.specialPrice' | translate }"
                  (ngModelChange)="calculatePrice()"
                />
              </div>

              <div class="field col-span-2">
                <div class="flex flex-wrap gap-4">
                  <div class="flex items-center">
                    <p-radiobutton
                      name="notUseSpecialPrices"
                      [value]="false"
                      [(ngModel)]="purchaseProductData.useSpecialPrice"
                      inputId="notUseSpecialPrice"
                      (ngModelChange)="calculatePrice()"
                    />
                    <label
                      for="notUseSpecialPrice"
                      class="ml-2"
                      >ใช้ราคาปกติ</label
                    >
                  </div>

                  <div class="flex items-center">
                    <p-radiobutton
                      name="useSpecialPrice"
                      [value]="true"
                      [(ngModel)]="purchaseProductData.useSpecialPrice"
                      inputId="useSpecialPrice"
                      (ngModelChange)="calculatePrice()"
                    />
                    <label
                      for="useSpecialPrice"
                      class="ml-2"
                      >ใช้ราคาพิเศษ</label
                    >
                  </div>
                </div>
              </div>

              <div class="field">
                <label for="sumAmount">{{ "purchaseDetailList.netPrice" | translate }}</label>
                <p-inputnumber
                  [(ngModel)]="purchaseProductData.sumAmount"
                  [pKeyFilter]="'num'"
                  id="sumAmount"
                  name="sumAmount"
                  mode="decimal"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [disabled]="true"
                />
                <p class="mb-0 mt-2 text-xs text-gray-400">
                  {{ this.purchaseProductData.weightTotal | number: "0.2" }} *
                  {{ this.purchaseProductData.useSpecialPrice ? (this.purchaseProductData.specialPricePerUnit | number: "0.2") : (this.purchaseProductData.pricePerUnit | number: "0.2") }}
                </p>
              </div>

              <div class="field">
                <label for="netWeight">{{ "weighing.weight" | translate }}</label>
                <p-inputnumber
                  [(ngModel)]="purchaseProductData.weightTotal"
                  [pKeyFilter]="'num'"
                  id="netWeight"
                  name="netWeight"
                  mode="decimal"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [disabled]="true"
                />
              </div>
            </div>
            <div class="field">
              <label for="note">{{ "note" | translate }}</label>
              <textarea
                class="_custom-text-area"
                id="note"
                name="note"
                rows="2"
                pTextarea
                [(ngModel)]="purchaseProductData.remark"
                [placeholder]="'placeholderInput' | translate: { placeholder: 'note' | translate }"
              ></textarea>
            </div>
          </div>
        </div>
      </form>
    } @else {
      <shared-products-purchased-detail
        [purchaseProductData]="purchaseProductData"
        [product]="purchaseProductData.product"
        [isBulkSale]="purchaseData.isBulkSale"
      ></shared-products-purchased-detail>
    }
  }
</lib-modal>
